import { Route } from '@angular/router';

export const SettlementRoutes: Route[] = [
  {
    path: 'settlement',
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/settlement/settlement.page'),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('../pages/settlement/settlement-detail/settlement-detail.page'),
      },
    ],
  },
];
